import { Link } from 'react-router-dom';
import tick from '../../../../../../assets/icons/new_icon/tickAnim.gif';
interface Props {
  response: any;
}
function UserCreationSteps({ response }: Props) {
  return (
    <div>
      {!response ? (
        <div
          className='row mt-4'
          id='spinner_detail'
        >
          <div className='col-sm-12 col-md-3'></div>
          <div className='col-sm-12 col-md-6'>
            <div className=''>
              <div className='card-body p-4 text-center'>
                <div
                  className='spinner-border my-5'
                  role='status'
                  style={{ width: '4rem', height: '4rem' }}
                >
                  <span className='visually-hidden'>Creating User...</span>
                </div>
              </div>
            </div>
          </div>
          <div className='col-sm-12 col-md-3'></div>
        </div>
      ) : (
        <div
          className='row mt-4'
          id='success_detail'
        >
          <div className='col-sm-12 col-md-3'></div>
          <div className='col-sm-12 col-md-6'>
            <div className=''>
              <div className='card-body p-4'>
                <div
                  id='check-mark'
                  className='text-center mt-5'
                >
                  <img src={tick} />
                  <p
                    className='globalInputLabel mb-0'
                    style={{
                      fontSize: '20px',
                      color: '#251163',
                      fontWeight: '500',
                    }}
                  >
                    Congratulation!
                  </p>
                  <p className=' globalInputLabel'>User has been created.</p>
                </div>

                <div className='row'>
                  <div className='col-12 text-center'>
                    <p
                      className='globalInputLabel'
                      style={{ fontWeight: '300' }}
                    >
                      User Name:{' '}
                      <span
                        id='user'
                        className='globalInputLabel ms-2'
                      >
                        {response?.username}
                      </span>
                    </p>
                    <p
                      className='globalInputLabel'
                      style={{ fontWeight: '300' }}
                    >
                      Password:{' '}
                      <span
                        id='password'
                        className='globalInputLabel ms-2'
                      >
                        {response?.password}
                      </span>
                    </p>
                  </div>
                </div>

                <div className='row pt-4'>
                  <div className='col-sm-12 text-center'>
                    <div
                      className='btn  btn-ubbe-new-back d-flex gap-2 m-auto '
                      style={{
                        maxWidth: 'max-content',
                        textDecoration: 'underline',
                      }}
                      onClick={() => {
                        window.history.back(); // Go back one page
                        // setShowUserDetailForm(false);
                      }}
                      id='account_link'
                    >
                      <svg
                        xmlns='http://www.w3.org/2000/svg'
                        width='15'
                        height='8'
                        viewBox='0 0 15 8'
                        fill='none'
                      >
                        <path
                          d='M3.03077 0.670207L0.176923 3.5735C0.123077 3.62828 0.0769229 3.69871 0.0461536 3.77697C0.0461536 3.7848 0.0461536 3.79262 0.0384613 3.80045C0.0153844 3.86305 -1.56239e-07 3.92566 -1.53161e-07 3.99609C-1.4632e-07 4.1526 0.0615383 4.30129 0.169231 4.41084L3.03077 7.32979C3.25385 7.55674 3.62308 7.55674 3.84615 7.32979C4.06923 7.10285 4.06923 6.72722 3.84615 6.50028L1.96154 4.58301L14.4231 4.58301C14.7385 4.58301 15 4.31694 15 3.99609C15 3.67524 14.7385 3.40917 14.4231 3.40917L1.96923 3.40917L3.84615 1.49972C3.96154 1.38234 4.01538 1.23365 4.01538 1.08496C4.01538 0.936277 3.96154 0.787591 3.84615 0.670207C3.62308 0.443265 3.26154 0.443265 3.03077 0.670207Z'
                          fill='black'
                        />
                      </svg>
                      Back to Accounts
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className='col-sm-12 col-md-3'></div>
        </div>
      )}
    </div>
  );
}

export default UserCreationSteps;
